<template>
  <div class="card card-custom card-stretch gutter-b">
    <div class="card-header border-0 py-5">
      <h3 class="card-title align-items-start flex-column">
        <span class="card-label font-weight-bolder text-dark">
          Novo Terminal
        </span>
      </h3>
    </div>
    <Form url="/pos/create" :pos="pos" />
  </div>
</template>

<script>
import Form from "./Form.vue";
import PosData from "./PosData";
import { mapGetters } from "vuex";

export default {
  name: "app-pos-create",
  data() {
    return {
      pos: new PosData({}),
    };
  },
  components: {
    Form,
  },
  computed: {
    ...mapGetters(["itsblocked"]),
  },
  mounted() {
    if (this.itsblocked) {
      this.$router.push({ name: "assinatura" });
    }
  },
};
</script>
